import { State, Action, StateContext, Selector, Store, Select } from '@ngxs/store';
import { patch } from '@ngxs/store/operators';
import { Injectable } from '@angular/core';
import * as TyreOfferActions from './tyre-offer.action';
import { TyreOfferService } from './tyre-offer.service';
import { BannerService } from '../../shared/services/banner.service';
import * as TyreOfferModels from '../../models/tyre-offer/tyre-offer';
import { TyreOfferSearchModel } from '../../models/tyre-offer/tyre-offerSearch';
import { HelperService } from '../../../../src/app/services/helper/helper.service';
import { saveAs } from 'file-saver';
import * as Models from '../../models/commonModels';


export interface TyreOfferStateModel {
    List: TyreOfferModels.TyreOfferListModel;
    PreviewList: Models.ResponseList<TyreOfferModels.TyreOfferModel>;
    Search: TyreOfferSearchModel;
    FilteredReportLoading: boolean;
    TyreOffer: Models.Response<TyreOfferModels.TyreOfferModel>;
  }

@State<TyreOfferStateModel>({
    name: 'tyreOfferState',
    defaults: {
      List: null,
      Search: null,
      FilteredReportLoading: false,
      PreviewList: null,
      TyreOffer: null
    }
  })

  @Injectable()

  export class TyreOfferState {

    constructor(
      private helperService: HelperService,
      private tyreOfferService: TyreOfferService,
      private bannerService: BannerService
  ) { }

  @Selector()
  static TyreOffer(state: TyreOfferStateModel) {
    return state.TyreOffer;
  }

  @Selector()
  static List(state: TyreOfferStateModel) {
    return state.List;
  }

  @Selector()
  static TyreOfferSearch(state: TyreOfferStateModel) {
    return state.Search;
  }

  @Selector()
  static FilteredReportLoading(state: TyreOfferStateModel) {
    return state.FilteredReportLoading;
  }

  @Selector()
  static PreviewList(state: TyreOfferStateModel) {
    return state.PreviewList;
  }

  @Action(TyreOfferActions.GetList)
  GetList(
    context: StateContext<TyreOfferStateModel>,
    action: TyreOfferActions.GetList
  ) {

    const errorMessage = 'Błąd pobierania listy ofert opon.';

    context.setState(
      patch({
        List: null
      })
    );

    this.tyreOfferService.geList(action.Search).subscribe((ret) => {

      if (ret.Success) {
        context.setState(
          patch({
            List: ret
          })
        );

        return ret;

      } else {
        this.bannerService.error(ret.Message, errorMessage);
      }
    },
      (error) => {
        this.helperService.SaveException('TyreOfferActions.GetList', error);

        this.bannerService.error(errorMessage);
      });
  }

  @Action(TyreOfferActions.SetSearch)
  SetSearch(
    context: StateContext<TyreOfferStateModel>,
    action: TyreOfferActions.SetSearch
  ) {

    action.Search.CurrentPage = 1;

    context.setState(
      patch({
        Search: action.Search
      }));

    context.dispatch(new TyreOfferActions.GetList(action.Search));
  }

  @Action(TyreOfferActions.SetListPage)
  SetListPage(
    context: StateContext<TyreOfferStateModel>,
    action: TyreOfferActions.SetListPage
  ) {

    context.setState(
      patch({
        Search: action.Search
      }));

    context.dispatch(new TyreOfferActions.GetList(action.Search));
  }

  @Action(TyreOfferActions.ResetSearch)
  ResetSearch(
    context: StateContext<TyreOfferStateModel>
  ) {

    const state = context.getState();

    const search = new TyreOfferSearchModel();

    search.ItemsPerPage = state.Search.ItemsPerPage;

    context.setState(
      patch({
        Search: search
      }));

    context.dispatch(new TyreOfferActions.GetList(search));
  }

  @Action(TyreOfferActions.GetFilteredReport)
  GetFilteredReport(
      context: StateContext<TyreOfferStateModel>,
      action: TyreOfferActions.GetFilteredReport
   ) {
        function patchContext( loading: boolean) {
          context.setState(
            patch ({
                FilteredReportLoading: loading
            })
          );
        }

        patchContext(true);
        const fileName = 'OfertyOpon';
        this.bannerService.info(`Rozpoczęto generowanie pliku raportu ${fileName}, proszę czekać ...`, 'Export danych');

        this.tyreOfferService.getReport(action.Search).subscribe (
              res => {
                const file = new File([res], `${fileName}-${this.helperService.TimeStamp()}.xlsx`, { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                saveAs(file);
                patchContext(false);
              },
              res => {
                patchContext(false);
                this.bannerService.error(`Błąd pobierania raportu: ${fileName}`);
              },
              () => {
                patchContext(false);
                this.helperService.consoleLog('TyreOfferActions.GetFilteredReport');
              }
          );
  }

  @Action(TyreOfferActions.Refresh)
  Refresh(
    context: StateContext<TyreOfferStateModel>,
    action: TyreOfferActions.Refresh
  ) {

    {
      const errorMessage = 'Błąd przywracania oferty do puli wolnych i aktywnych.';
      this.tyreOfferService.refresh(action.TyreOffer).subscribe((ret) => {

        context.setState(
          patch({
            TyreOffer: ret
          })
        );

        if (ret.Success) {
          this.bannerService.success(`Oferta ${ret.Item.TyreOfferId} została przywrócona do puli wolnych i aktywnych. `);
        }
        else {
          this.bannerService.error(ret.Message);
        }

      },

        (error) => {
          context.setState(
            patch({
              TyreOffer: null
            })
          );

          this.helperService.SaveException('TyreOfferActions.GetList', error);
          this.bannerService.error(errorMessage);
        });
    }
  }

  @Action(TyreOfferActions.Set)
  Set(
    context: StateContext<TyreOfferStateModel>,
    action: TyreOfferActions.Set
  ) {
      const errorMessage = `Błąd aktualizacji oferty ${action.TyreOffer.Item.TyreOfferId}.`;

      this.tyreOfferService.set(action.TyreOffer).subscribe((ret) => {

      if (ret.Success) {
        this.bannerService.success(`Oferta (${ret.Item.TyreOfferId}) została zaktualizowana.`);
      }
      else {
        this.bannerService.error(ret.Message);
      }

      context.setState(
        patch({
          TyreOffer: ret
        })
      );
    },

      (error) => {
        context.setState(
          patch({
            TyreOffer: null
          })
        );

        this.helperService.SaveException('TyreOfferActions.AddGarageToTyreOffer', error);
        this.bannerService.error(errorMessage);
      });
  }

  @Action(TyreOfferActions.Assign)
  Assign(
    context: StateContext<TyreOfferStateModel>,
    action: TyreOfferActions.Assign
  ) {
    const errorMessage = `Błąd przypisania oferty ${action.TyreOffer.Item.TyreOfferId}.`;

    this.tyreOfferService.assign(action.TyreOffer).subscribe((ret) => {

      if (ret.Success) {
        this.bannerService.success(`Oferta (${ret.Item.TyreOfferId}) została przypisana.`);
      }
      else {
        this.bannerService.error(ret.Message);
      }

      context.setState(
        patch({
          TyreOffer: ret
        })
      );
    },

      (error) => {
        context.setState(
          patch({
            TyreOffer: null
          })
        );

        this.helperService.SaveException('TyreOfferActions.Assign', error);
        this.bannerService.error(errorMessage);
      });
  }

  @Action(TyreOfferActions.DisposeSearch)
  DisposeSearch(
      context: StateContext<TyreOfferStateModel>
    ) {

      context.setState(
        patch({
          Search: null
        }));
  }

  @Action(TyreOfferActions.GetPreviewList)
  GetPreviewList(
    context: StateContext<TyreOfferStateModel>,
    action: TyreOfferActions.GetList
  ) {

    const errorMessage = 'Błąd pobierania listy ofert opon.';

    context.setState(
      patch({
        List: null
      })
    );

    this.tyreOfferService.gePreviewList(action.Search).subscribe((ret) => {

      if (ret.Success) {
        context.setState(
          patch({
            PreviewList: ret
          })
        );

        return ret;

      } else {
        this.bannerService.error(ret.Message, errorMessage);
      }
    },
      (error) => {
        this.helperService.SaveException('TyreOfferActions.GetPreviewList', error);

        this.bannerService.error(errorMessage);
      });
  }
}
